import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';

const Icon = (): React.JSX.Element => {
	return <AtlassianIcon appearance="brand" />;
};

export default Icon;
